import { useMutation } from '@tanstack/react-query';

import { toLoginEmailCheck } from './mappers';
import type { LoginEmailCheck } from './types';

/**
 * Not in the generated client. It stays a plain same-origin `fetch`, as the login screen always
 * sent it: no session exists yet, and the axios client's JSON-patch content type does not apply.
 */
async function checkLoginEmail(email: string): Promise<LoginEmailCheck> {
    const response = await fetch('/api/v2/auth/check-email', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
    });
    const body: unknown = response.ok
        ? await response.json()
        : await response.json().catch(() => null);
    return toLoginEmailCheck(response.status, response.ok, body);
}

/**
 * Looks up which sign-in options an email's organisation has. Resolves with the rejection
 * reason for a 4xx/5xx reply and rejects only on a network failure or an unreadable reply.
 */
export function useCheckLoginEmail(): (email: string) => Promise<LoginEmailCheck> {
    const { mutateAsync } = useMutation({ mutationFn: checkLoginEmail });
    return mutateAsync;
}
